import { render, staticRenderFns } from "./LeatherCategories.vue?vue&type=template&id=03856949&scoped=true"
var script = {}
import style0 from "./LeatherCategories.vue?vue&type=style&index=0&id=03856949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03856949",
  null
  
)

export default component.exports